import {
    GET_ORDERS_SUMMARY,
    GET_ORDERS_SUMMARY_SUCCESS,
    GET_ORDERS_SUMMARY_FAILURE,
    SET_SEND_REPORT_MODAL_STATE,
    SET_ORDER_SUMMARY_MODAL_STATE,
    CLOSE_ORDER_SUMMARY_MODAL_STATE,
    SHOW_HIDE_SUMMARY_MODAL,
    SET_ORDER_STATE,
    SHOW_HIDE_SAVEASTEMPLATE,
    SET_ORDERSUMMARY_TAB,
    SHOW_HIDE_REQUEST_INVOICE,
    SHOW_HIDE_SEND_REPORT_MODAL,
    SET_REPORT_PROCEDURE_MODAL_STATE,
    SHOW_HIDE_REPORT_PROCEDURE_MODAL,
    SET_DESCREPENCY_IMAGE_VIEW,
    SET_IMPLANT_AND_INSTRUMENT_PRODUCTS,
    SET_ITEM_LIST_VIEW,
    PROCEDURE,
} from '../actions';
import { OrderSummaryTabs } from 'src/constants/orderListConstants.js';

const initialState = {
    loading: false,
    backOrders: [],
    billingSummary: {},
    orderDetails: [],
    orderBasicDetails: {},
    priceOverride: {},
    replenishmentRequests: [],
    setAvailabilityPending: [],
    shipAndTrack: [],
    lastModifiedDate: '',
    lastModifiedName: '',
    sendReportModal: false,
    orderSummaryModal: false,
    myCaseRef: '',
    tabLists: [],
    showSummaryModal: true,
    orderStatus: '',
    callToActionList: [],
    showSaveAsTemplate: false,
    selectedTabId: OrderSummaryTabs()[0].id,
    requestInvoiceState: false,
    isUsageReportOrderListPage: false,
    isUsageReportSearchListPage: false,
    isRequestInvoiceOrderListPage: false,
    isRequestInvoiceSearchListPage: false,
    createdBy: '',
    createdByTime: '',
    showReportProcedureModal: false,
    showBackButton: false,
    reportProcedureData: [],
    descrepencyImageView: false,
    statusCode: '',
    statusMessage: '',
    isItemListView: false,
    implantProducts: [],
    instrumentProducts: [],
    procedureCall:false,
};

const resetOrderSummaryHandler = () => {
    return {
        loading: initialState.loading,
        backOrders: initialState.backOrders,
        billingSummary: initialState.billingSummary,
        orderDetails: initialState.orderDetails,
        orderBasicDetails: initialState.orderBasicDetails,
        priceOverride: initialState.priceOverride,
        replenishmentRequests: initialState.replenishmentRequests,
        setAvailabilityPending: initialState.setAvailabilityPending,
        shipAndTrack: initialState.shipAndTrack,
        lastModifiedDate: initialState.lastModifiedDate,
        lastModifiedName: initialState.lastModifiedName,
        tabLists: initialState.tabLists,
        callToActionList: initialState.callToActionList,
        selectedTabId: OrderSummaryTabs()[0].id,
        isUsageReportOrderListPage: initialState.isUsageReportOrderListPage,
        isUsageReportSearchListPage: initialState.isUsageReportSearchListPage,
        isRequestInvoiceOrderListPage:
            initialState.isRequestInvoiceOrderListPage,
        isRequestInvoiceSearchListPage:
            initialState.isRequestInvoiceSearchListPage,
        createdBy: initialState.createdBy,
        createdByTime: initialState.createdByTime,
        showReportProcedureModal: initialState.showReportProcedureModal,
        reportProcedureData: initialState.reportProcedureData,
    };
};

const OrderSummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDERS_SUMMARY:
            return {
                ...state,
                loading: true,
                statusCode: '',
                statusMessage: '',
            };
        case GET_ORDERS_SUMMARY_SUCCESS: {
            const createdByValue = action?.data?.createdBy;
            const createdByParts =
                typeof createdByValue === 'string'
                    ? createdByValue?.split('*$*')
                    : [];

            return {
                ...state,
                ...action.data,
                loading: false,
                procedureCall: true,
                reportProcedureData: action.data.reportProcedureData,
                createdBy: createdByParts[0] || '',
                createdByTime: createdByParts[1] || '',
                selectedTabId: action.data?.selectedTabId
                    ? action.data.selectedTabId
                    : state.selectedTabId,
                statusCode: '',
                statusMessage: '',
            };
        }
        case GET_ORDERS_SUMMARY_FAILURE:
            return {
                ...state,
                loading: false,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
            };
        case PROCEDURE:
            return {
                ...state,
                procedureCall: false,
            };
        case SET_SEND_REPORT_MODAL_STATE:
            return {
                ...state,
                sendReportModal: action.payload.showModal
                    ? action.payload.showModal
                    : state.sendReportModal,
                myCaseRef: action.payload.myCaseRefId,
                isUsageReportOrderListPage:
                    action.payload.isUsageReportOrderListPage !== undefined
                        ? action.payload.isUsageReportOrderListPage
                        : state.isUsageReportOrderListPage,
                isUsageReportSearchListPage:
                    action.payload.isUsageReportSearchListPage !== undefined
                        ? action.payload.isUsageReportSearchListPage
                        : state.isUsageReportSearchListPage,
            };
        case SET_ORDER_SUMMARY_MODAL_STATE:
            return {
                ...state,
                loading: true,
                statusCode: '',
                statusMessage: '',
            };
        case CLOSE_ORDER_SUMMARY_MODAL_STATE: {
            const resetOrderSummary = resetOrderSummaryHandler();

            return {
                ...state,
                ...action.payload,
                ...resetOrderSummary,
            };
        }
        case SHOW_HIDE_SUMMARY_MODAL:
            return {
                ...state,
                ...action.payload,
            };
        case SET_REPORT_PROCEDURE_MODAL_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case SET_ORDER_STATE:
            return {
                ...state,
                orderStatus: action.payload,
            };
        case SHOW_HIDE_SAVEASTEMPLATE:
            return {
                ...state,
                ...action.data,
            };
        case SET_ORDERSUMMARY_TAB:
            return {
                ...state,
                ...action.data,
            };
        case SHOW_HIDE_REQUEST_INVOICE:
            return {
                ...state,
                requestInvoiceState: action.payload.requestInvoiceState,
                myCaseRef: action.payload.myCaseRefId,
                isRequestInvoiceOrderListPage:
                    action.payload.isRequestInvoiceOrderListPage !== undefined
                        ? action.payload.isRequestInvoiceOrderListPage
                        : state.isRequestInvoiceOrderListPage,
                isRequestInvoiceSearchListPage:
                    action.payload.isRequestInvoiceSearchListPage !== undefined
                        ? action.payload.isRequestInvoiceSearchListPage
                        : state.isRequestInvoiceSearchListPage,
            };
        case SHOW_HIDE_SEND_REPORT_MODAL:
            return {
                ...state,
                ...action.payload,
            };
        case SHOW_HIDE_REPORT_PROCEDURE_MODAL:
            return {
                ...state,
                showBackButton: action.payload,
            };
        case SET_DESCREPENCY_IMAGE_VIEW:
            return {
                ...state,
                descrepencyImageView: action.payload,
            };
        case SET_ITEM_LIST_VIEW:
            return {
                ...state,
                isItemListView: action.payload,
            };
        case SET_IMPLANT_AND_INSTRUMENT_PRODUCTS:
            return {
                ...state,
                implantProducts: action.payload.implantProducts,
                instrumentProducts: action.payload.instrumentProducts,
            };
        default:
            return {
                ...state,
            };
    }
};

export default OrderSummaryReducer;
